import { createReducer } from '@reduxjs/toolkit';
import { IRoleState } from './types';
import { fetchRoleList } from './actions';

const initialState: IRoleState = {
  loading: false,
  list: {
    data: [],
  },
  error: null,
};

export const roleReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchRoleList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchRoleList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchRoleList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});